import React from 'react';

const bigRefStyle = {
    border: "4px dashed #BFA26D",
    padding: ".75rem",
    lineHeight: 1,
    fontWeight: "800 !important",
    fontSize: "2rem",
    display: "inline-block",
    marginBottom: "2rem",
    borderRadius : "6px"
}

const BigRef = (props) => {
    return(
        <div className="ref-big-code" style={bigRefStyle}>
            {props.refCode}
        </div>
    );
}

export default BigRef;